import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { capatelize } from 'src/app/SEO_Constant/routes.constant';
import { description, keyword } from 'src/app/SEO_Constant/seo';
@Component({
    selector: 'app-software-development',
    templateUrl: './software-development.component.html',
    styleUrls: ['./software-development.component.css'],
    standalone: false
})
export class SoftwareDevelopmentComponent implements OnInit {
  titles:any
  bannerArray:any = {
    "bannerTXT" : [
      {
        title: 'Web development services help create all types of web-based software.',
      },
      {
        title: 'Web development is the building and maintenance of websites.',
      },
      {
        title: 'It`s make website look great.',
      },
      {
        title: 'Work fast and perform well with a seamless user experience.',
      },
    ],
    "bannerImg" : {
      "banner": "assets/img/web_dev.png",
      "backgroundImg": "assets/img/banner-background.jpg"
    }
  }

  constructor( private title : Title,private router: Router,private meta: Meta ) {
    this.titles = router.url.split('/')[router.url.split('/').length-1].replace(/-/g,' ')
   }

  ngOnInit(): void {
    this.title.setTitle(capatelize(this.titles) + ' | Resiliencesoft')
     this.meta.removeTag('name=description');
        this.meta.removeTag('name=keywords');
        this.meta.addTags([
          {
            name: 'description',
            content: description.WebDevelopment,
          },
          {
            name: 'keywords',
            content: capatelize(keyword.globle) + capatelize(keyword.WebDevelopment),
          },
        ]);
  }

}
